const axios = require('axios')

const postExpansionMessage = async formData => {
  const res = await axios({
    method: 'post',
    url: process.env.GATSBY_API_FORMS,
    data: formData,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: { op: 'expansion' }
  })

  return {
    response: res
  }
}

const postContactMessage = async formData => {
  const res = await axios({
    method: 'post',
    url: process.env.GATSBY_API_FORMS,
    data: formData,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: { op: 'contact' }
  })

  return {
    response: res
  }
}

const postPressContactMessage = async formData => {
  const res = await axios({
    method: 'post',
    url: process.env.GATSBY_API_FORMS,
    data: formData,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: { op: 'pressContact' }
  })

  return {
    response: res
  }
}

const postPressPermitMessage = async formData => {
  const res = await axios({
    method: 'post',
    url: process.env.GATSBY_API_FORMS,
    data: formData,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: { op: 'pressPermit' }
  })

  return {
    response: res
  }
}

const postApplicationMessage = async formData => {
  const res = await axios({
    method: 'post',
    url: process.env.GATSBY_API_FORMS,
    data: formData,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: { op: 'application' }
  })

  return {
    response: res
  }
}
const postCancelMessage = async formData => {
  const res = await axios({
    method: 'post',
    url: process.env.GATSBY_API_FORMS,
    data: formData,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: { op: 'cancel' }
  })

  return {
    response: res
  }
}

const postEmployeeMessage = async formData => {
  const res = await axios({
    method: 'post',
    url: process.env.GATSBY_API_FORMS,
    data: formData,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: { op: 'employeeCard' }
  })

  return {
    response: res
  }
}

const postDynamicFormMessage = async (fields, formSlug, files = []) => {
  const formData = new FormData()

  formData.append('formSlug', formSlug)

  fields.forEach(field => {
    formData.append(field.name, field.value)
  })

  files.forEach(file => {
    formData.append(file.fieldName, file.file)
  })

  const res = await axios.post(process.env.GATSBY_API_FORMS, formData, {
    params: { op: 'dynamicForm' }
  })

  return { response: res }
}

module.exports = {
  postContactMessage,
  postExpansionMessage,
  postApplicationMessage,
  postEmployeeMessage,
  postCancelMessage,
  postPressContactMessage,
  postPressPermitMessage,
  postDynamicFormMessage
}
